<div class="row coreteam-item">
    <div class="col-sm-2">
    
    </div>
    <div class="col-sm-3">
    
    <img src="/assets/images/coreteam/emma.png" width="250px">
    </div>
    <div class="col-sm-7">
    <h4>Emmanuel Kansiime Muntu</h4>
    <p><u>Chief Financial Officer(CFO)</u></p>
    Emmanuel  takes on the primary responsibility for managing the Boldungu financial health, including financial planning, management of financial risks, record-keeping, and financial reporting. He draws his expertise from various projects he has crafted and managed in various ogranisations. 
    </div>
